var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon ",
    viewBox: "0 0 64 64",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1px"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.2,34.2c0.8-0.1,1.4-0.8,1.3-1.6c-0.1-0.8-0.8-1.4-1.6-1.3C21,31.6,18,34.9,18,38.8c0,4.2,3.4,7.7,7.7,7.7c3.9,0,7.2-2.9,7.6-6.9c0.1-0.8-0.5-1.6-1.3-1.6c-0.8-0.1-1.6,0.5-1.6,1.3c-0.2,2.4-2.2,4.2-4.6,4.2c-2.6,0-4.7-2.1-4.7-4.7C21,36.4,22.8,34.4,25.2,34.2z",
    stroke: "none",
    strokeWidth: "1px"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.6,8.2l-2.8-2.8c-0.8-0.8-2-1.3-3.2-1.3s-2.3,0.5-3.2,1.3L33.6,21.2l-3.7,12.9l12.9-3.7l15.8-15.8c0.8-0.8,1.3-2,1.3-3.2C60,10.2,59.5,9.1,58.6,8.2z M41.2,27.8l-6.9,2l2-6.9L47,12.1l4.9,4.9L41.2,27.8z M56.5,12.5L54,14.9L49.1,10l2.5-2.5c0.6-0.6,1.6-0.6,2.1,0l2.8,2.8c0.3,0.3,0.4,0.7,0.4,1.1S56.8,12.2,56.5,12.5z",
    stroke: "none",
    strokeWidth: "1px"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45,35.6L43.4,35c-0.8-0.3-1.6,0.1-1.9,0.9s0.1,1.6,0.9,1.9L43,38v1.7l-4.4,1.9c-0.3,0.1-0.6,0.4-0.7,0.7l-1.2,2.3c-0.2,0.3-0.2,0.7-0.1,1.1l1.5,4.9l-1,1l-4.4-1.4c-0.3-0.1-0.7-0.1-1,0l-2.9,1.2c-0.4,0.2-0.7,0.5-0.9,0.9L26.5,56h-2l-1.4-3.7c-0.1-0.4-0.5-0.7-0.9-0.9l-2.9-1.2c-0.3-0.1-0.7-0.1-1,0l-4.4,1.4l-1-1l1.5-4.9c0.1-0.4,0.1-0.8-0.1-1.1l-1.2-2.3c-0.2-0.3-0.4-0.6-0.7-0.7L8,39.8v-1.5l4.4-1.9c0.3-0.1,0.6-0.4,0.7-0.7l1.2-2.3c0.2-0.3,0.2-0.7,0.1-1.1l-1.5-4.9l1-1l4.4,1.4c0.3,0.1,0.7,0.1,1,0l2.9-1.2c0.4-0.2,0.7-0.5,0.9-0.9l1.4-3.7h2.1l0.2,0.6c0.3,0.8,1.2,1.2,1.9,0.9c0.8-0.3,1.2-1.2,0.9-1.9L29,20c-0.2-0.6-0.8-1-1.4-1h-4.1c-0.6,0-1.2,0.4-1.4,1l-1.5,4l-1.8,0.7L14,23.1c-0.5-0.2-1.1,0-1.5,0.4l-2.3,2.3c-0.4,0.4-0.5,1-0.4,1.5l1.6,5.2l-0.7,1.3l-4.8,2.1C5.4,36.1,5,36.7,5,37.3v3.5c0,0.6,0.4,1.1,0.9,1.4l4.8,2.1l0.7,1.3l-1.6,5.2c-0.2,0.5,0,1.1,0.4,1.5l2.3,2.3c0.4,0.4,1,0.5,1.5,0.4l4.7-1.6l1.8,0.7l1.5,4c0.2,0.6,0.8,1,1.4,1h4.1c0.6,0,1.2-0.4,1.4-1l1.5-4l1.8-0.7l4.7,1.6c0.5,0.2,1.1,0,1.5-0.4l2.3-2.3c0.4-0.4,0.5-1,0.4-1.5l-1.6-5.2l0.7-1.3l4.8-2.1c0.5-0.2,0.9-0.8,0.9-1.4V37C46,36.4,45.6,35.8,45,35.6z",
    stroke: "none",
    strokeWidth: "1px"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.5a41e94213143ee25e39eef6fb796027.svg";